<template>
  <el-row class="form-style">
    <el-col :span="8" style="margin-left:-2px;display:flex">
      <el-col :span="9" class="form-title">统一社会信用代码</el-col>
      <el-col :span="15" class="form-value">{{baseInfo.creditCode}}</el-col>
    </el-col>
    <el-col :span="8" style="margin-left:-2px;display:flex">
      <el-col :span="9" class="form-title">组织机构代码</el-col>
      <el-col :span="15" class="form-value">{{baseInfo.companyCode}}</el-col>
    </el-col>
    <el-col :span="8" style="margin-left:-2px;display:flex">
      <el-col :span="9" class="form-title">工商注册号</el-col>
      <el-col :span="15" class="form-value">{{baseInfo.regNumber}}</el-col>
    </el-col>
    <el-col :span="8" style="margin-left:-2px;display:flex">
      <el-col :span="9" class="form-title">公司类型</el-col>
      <el-col :span="15" class="form-value">{{baseInfo.regType}}</el-col>
    </el-col>
    <el-col :span="8" style="margin-left:-2px;display:flex">
      <el-col :span="9" class="form-title">法定代表人</el-col>
      <el-col :span="15" class="form-value">{{baseInfo.faRen}}</el-col>
    </el-col>
    <el-col :span="8" style="margin-left:-2px;display:flex">
      <el-col :span="9" class="form-title">联系方式</el-col>
      <el-col :span="15" class="form-value">{{baseInfo.phone}}</el-col>
    </el-col>
    <el-col :span="8" style="margin-left:-2px;display:flex">
      <el-col :span="9" class="form-title">所属行业</el-col>
      <el-col :span="15" class="form-value">{{baseInfo.industry}}</el-col>
    </el-col>
    <el-col :span="16" style="margin-left:-2px;display:flex">
      <el-col :span="5" class="form-title" id="address-title">注册地址</el-col>
      <el-col :span="20" class="form-value" id="address-value">{{baseInfo.address}}</el-col>
    </el-col>
  </el-row>
</template>

<script>
import * as getData from './../service/getData'
export default {
  props: ['baseInfo'],
  name: '',
  components: {},
  data () {
    return {
      baseData: {}
    }
  },

  mounted() {
  },
  watch: {
    
  },
  methods: {
    init() {
      
    }
  }
}

</script>
<style lang='scss' scoped>
.form-title{
  min-height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e9fb;
  background: #f6faff;
  margin: 0 -1px -1px 0;
  text-align: center;
}
.form-value{
  min-height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #e0e9fb;
  margin: 0 0 -1px 0;
}
.form-style{
  position:relative;
  left:4px;
  display: flex;
  flex-wrap: wrap;
}
#address-title{
  width: 18.7%;
  height: 100%;
}
#address-value{
  width: 81.1%;
}
</style>



// WEBPACK FOOTER //
// src/components/company-business-info.vue